export const zoom = () => {
    let zoom = document.getElementsByTagName('body')[0].style.zoom
    return zoom
  }